import controller from './things-list.controller';

const template = require('./things-list.html');

export default {
    bindings: {
        onSelectThing: '&',
        onListReorder: '&',
        onThingStarred: '&',
        things: '<',
        metadata: '<',
        selectedThings: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/things-list/things-list.component.js